import React from 'react';

export default {
	'Error.Unknown': 'Errore sconosciuto',
	'Error.Unknown.Message': 'Si è verificato un errore.',
	'Error.NotFound': 'Non trovato',
	'Error.NotFound.Message': 'La pagina richiesta non è stata trovata.',
	'Error.Forbidden': 'Proibita',
	'Error.Forbidden.Message': 'Non ti è consentito accedere a questa pagina.',
	'Error.Invalid': 'Input non valido',
	'Error.Invalid.Message': 'Campi non validi: {{fields}}.',
	'Error.FileSize.Message': 'Il file che hai provato a caricare era troppo grande.',
	'PTMD Portal': 'PTMD Portale',
	'Login': 'Login',
	'Logout': 'Esci',
	'FileDrop.Release': 'Rilascia per selezionare il file',
	'FileDrop.Drag': () => <h5>Trascina e rilascia un file qui<br/> oppure </h5>,
	'FileDrop.Select': 'Seleziona un file',
	'GiB': '{{size}} GiB',
	'MiB': '{{size}} MiB',
	'KiB': '{{size}} KiB',
	'bytes': '{{size}} byte',
	'FileSize.Max': 'La dimensione massima di caricamento è {{size}}',
	'Modal.Open': 'Aprire',
	'Modal.Close': 'Vicino',
	'Language': 'Lingua'
};
